/**
 * Площади
 */
export default class AreaInfo {
  constructor() {
    this.max_area = 0;
    this.total_area = 0;
    this.order_area = 0;
    this.active_area = 0;
  }
}